import $ from 'jquery';

class Initializer {
  constructor() {
    this.components = [
      'Container',
      'DatePicker',
      'DateTime',
      'DockerImagesTextbox',
      'EdgeMonitor',
      'EdgeTokenFormSection',
      'Field',
      'FiltersIndexPage',
      'FirewallPolicyPreview',
      'HashBuilder',
      'HashForm',
      'HashPropertyActions',
      'Hierarchy',
      'Impact',
      'NodeRQLSearch',
      'PackageLogPage',
      'QRCodeBatchSearch',
      'RQLSearchHtmx',
      'RpmLogPreview',
      'RVCTextbox',
      'Reports',
      'ServiceCheckTextbox',
      'StoreHierarchyWidget',
      'Timezone',
    ];
    this.initializedComponents = [];
  }

  unregister() {
    this.initializedComponents.map((component) => {
      if (typeof component.unmount === 'function') {
        component.unmount();
      }
    });
    this.initializedComponents = [];
  }

  register() {
    this.components.map((component) => {
      $(`.Component-${component}`).each((i, item) => {
        this.initializedComponents.push(new window[component]($(item)));
      });
    });
  }
}

module.exports = Initializer;
